import {
  GET_SOFT_COLLECT_LIST,
  GET_SPECIAL_COLLECT_LIST,
  ADD_COLLECT_SPECIAL_SOFT,
  DELETE_COLLECT_SPECIAL_SOFT,
  SET_SOFT_COLLECT_LIST,
  SET_SPECIAL_COLLECT_LIST,
} from '../constants/collection';

export const getSoftCollectList = payload => ({
  type: GET_SOFT_COLLECT_LIST,
  payload,
});

export const getSpecialCollectList = payload => ({
  type: GET_SPECIAL_COLLECT_LIST,
  payload,
});

export const addCollectSpecial = payload => ({
  type: ADD_COLLECT_SPECIAL_SOFT,
  payload,
});
export const deleteCollectSpecial = payload => ({
  type: DELETE_COLLECT_SPECIAL_SOFT,
  payload,
});

export const updateSoftCollectList = payload => ({
  type: SET_SOFT_COLLECT_LIST,
  payload,
});

export const updateSpecialCollectList = payload => ({
  type: SET_SPECIAL_COLLECT_LIST,
  payload,
});
